import authReducer from "./authReducer";

export * from "./authReducer";

export default authReducer;
